routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
     .state('home.procedureDetail', {
       url: __env.routes.procedureDetail,
       template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    })
    .state('home.procedureDetailSlug', {
      url: __env.routes.procedureDetailSlug,
      template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    })
    .state('home.procedureDetailId', {
      url: __env.routes.procedureDetailId,
      template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/procedure-detail/procedure-detail.config.js
 **/